"use client"
import { createContext, useContext, useEffect, useState } from 'react';
import SimpleBackdrop from '../components/Backdrop/SimpleBackdrop';
import DraggableDialog from '../hooks/Dialog';
import CustomizedSnackbar from '../hooks/Snackbar';
import axios from 'axios';
import { getUserData } from '../hooks/HelperFunctions';
import CryptoJS from "crypto-js";
import { useRouter } from 'next/navigation';

const CommonContext = createContext();

export const useCommon = () => useContext(CommonContext);

export const CommonProvider = ({ children }) => {
    let router = useRouter()
    const [updateCart, setUpdateCart] = useState(true);
    const [openSignUpModel, setOpenSignUpModel] = useState(false);
  
    const [userData, setUserData] = useState([]);
    const [userToken, setUserToken] = useState("");
    const [userAuthenticated, setUserAuthenticated] = useState(false);
  
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogBody, setDialogBody] = useState("");
  
    const [openBackdrop, setOpenBackdrop] = useState(false);
  
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // severity can be: success, error, warning, info, success
    const [snackbarMessage, setSnackbarMessage] = useState("");
  
    const [enrollCourse, setEnrollCourse] = useState();
    

    useEffect(() => {
        setUserData(JSON.parse(localStorage.getItem("userData")));
        setUserToken(localStorage.getItem("userToken"));
        setUserAuthenticated(localStorage.getItem("userAuthenticated"));
      }, []);

    const enrollNowHandler = (course, authorized = "false") => {
        authorized = (authorized && authorized == "true" )? "true" : "false";

        if (userAuthenticated == "true" || authorized == "true") {
          
          setEnrollCourse(course);
          
          handleOpenDialog(
            "Enroll course for free",
            <div className="ModalDetails">
                    <h2>{course?.courseTitle}</h2>
                    <p>{Number.isInteger(course?.leadInstructor) ? `${course?.instructor_first_name} ${course?.instructor_last_name}` : course?.leadInstructor}</p>
                </div>
            );
          } else {
          
            localStorage.setItem("pendingOperation", "enrollment");
            localStorage.setItem("pendingOperationData", JSON.stringify(course));
            setOpenSignUpModel(true);
        }
    };

    const enrollNowTrackTermHandler = (term, authorized = "false") => {
      if (userAuthenticated == "true" || authorized == "true") {
  
          // setEnrollCourse(term);
          
          handleOpenDialog(
              "Enroll term for free",
              <div className="ModalDetails">
                  <h2>{term?.trackTermName}</h2>
              </div>
          );
      } else {
          localStorage.setItem("pendingOperation", "enrollment");
          localStorage.setItem("pendingOperationType", "track");
          localStorage.setItem("pendingOperationData", JSON.stringify(term));
          setOpenSignUpModel(true);
      }
  };

    const handleOpenDialog = (title, body) => {
        setDialogTitle(title);
        setDialogBody(body);
        setOpenDialog(true);
      };

    const showSnackbarMessage = (severity, message) => {
        setSnackbarSeverity(severity);
        setSnackbarMessage(message);
        setShowSnackbar(true);
      };

      /**
   * When click on snackbar close btn
   */
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const showCourseEnrollMessage = (response) => {
    if (response.data.body.status == true) {
      const userData = getUserData();
      
      // redirect to portal sign in page
      const portalUrl =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
          : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;
      const tokenData = {
        email: userData.email,
        phone_number: userData.phone_number,
        userToken: userToken,
      };
      var token = CryptoJS.AES.encrypt(
        JSON.stringify([tokenData]),
        "login-854256-secret-key"
      ).toString();
      // window.location.replace(
      //   `${portalUrl}/token-based-signin?token=${token}&enrollment=success`
      // );
      router.push(`/my-learning?enrollment=success`);
    } else {
      setSnackbarSeverity("error");
      setSnackbarMessage(response.data.body.message);
      setShowSnackbar(true);
    }
  };

  const handleConfirmCloseDialog = () => {
    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;
        
    let activeUserToken = localStorage.getItem("userToken");

    // Request interceptors for API calls
    axios.interceptors.request.use(
      (config) => {
        config.headers["Authorization"] = `Bearer ${activeUserToken}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    const adminPortalURL =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
        : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;

    const userData = getUserData();
    const postData = {
      userId: userData.id,
      courseId: enrollCourse.courseId,
      adminPortalURL: adminPortalURL,
    };

    // hide dialog box
    setOpenDialog(false);
    // show loader
    setOpenBackdrop(true);

    axios
      .post(`${baseUrl}/studentPortal/enrollNow`, postData)
      .then((response) => showCourseEnrollMessage(response))
      .catch((err) => {
        console.log(err);
        if (err.response.data.message) {
          setSnackbarSeverity("error");
          setSnackbarMessage(err.response.data.message);
          setShowSnackbar(true);
        }
      });

    return true;
  };


  return (
    <>
        <CommonContext.Provider value={{ 
            updateCart,
            setUpdateCart,
            openSignUpModel,
            enrollNowHandler,
            enrollNowTrackTermHandler,
            setOpenSignUpModel, 
            showSnackbarMessage,
            setOpenBackdrop,
            openDialog,
            dialogTitle,   
            dialogBody,
            handleCloseDialog, 
            handleConfirmCloseDialog,  
            showSnackbar,  
            snackbarSeverity,  
            snackbarMessage,   
            handleSnackbarClose,   
            openBackdrop,  
            handleCloseBackdrop
            }}>
                
        {children}
        </CommonContext.Provider>
    </>
  );
};